import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import Loader from "../common/Loader";
import { updateOpeningBalanceAll } from "../store/slices/ledger";
import { toast } from "react-hot-toast";

const AddOpeningBalancePop = ({ show, onClose, ledgerItem, onSuccess, specialOpeningData }) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const profile_id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [opening_date, setOpeningDate] = useState("");
  const [opening_balance, setOpeningBalance] = useState("");
  const [dr_cr, setDrCr] = useState("cr");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show && ledgerItem) {
      // default values or prefill from fetched special opening data
      const rawOpening = specialOpeningData?.opening_balance ?? ledgerItem?.opening_balance;
      let normalizedOpening = "";
      if (rawOpening !== null && rawOpening !== undefined && rawOpening !== "") {
        const n = Number(rawOpening);
        normalizedOpening = !Number.isNaN(n) && n !== 0 ? String(rawOpening) : "";
      }

      setOpeningDate(specialOpeningData?.opening_date || "");
      setOpeningBalance(normalizedOpening);
      setDrCr((specialOpeningData?.dr_cr || ledgerItem?.dr_cr || "cr").toLowerCase());
      setErrors({});
    }
  }, [show, ledgerItem, specialOpeningData]);

  const validateAmount = (value) => {
    const regex = /^-?\d*(\.\d{0,2})?$/;
    if (value === "-" || regex.test(value)) return value;
    return value.slice(0, -1);
  };

  const handleSubmit = async (e) => {
    e && e.preventDefault();
    if (!opening_balance || Number(opening_balance) === 0) {
      setErrors((prev) => ({
        ...prev,
        opening_balance: "Amount is required",
      }));
      return;
    }
    // opening date optional, but validate format if provided

    const payload = {
      profile_id: Number(profile_id),
      ledger_id: Number(ledgerItem?.id),
      opening_balance: opening_balance,
      opening_date: opening_date,
      dr_cr: dr_cr,
    };

    setIsLoading(true);
    try {
      await dispatch(updateOpeningBalanceAll(payload)).unwrap();

      setIsLoading(false);
      toast.success("Opening balance added/updated successfully");
      onClose();
      onSuccess && onSuccess();
    } catch (err) {
      setIsLoading(false);
      console.error(err);
      toast.error(err?.message || "Failed to update opening balance");
    }
  };

  if (!ledgerItem) return null;

  return (
    <Modal show={show} onHide={onClose} size="md" centered>
      {isLoading && <Loader />}
      <Modal.Header>
        <Modal.Title>Add Opening Balance - {ledgerItem?.ledger}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6">
            <label>Opening Date</label>
            <input
              className="form-control"
              type="date"
              value={opening_date}
              onChange={(e) => setOpeningDate(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="col-black mb-0">Amount</label>
              <div className="ml-2">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dr_cr"
                    id="credit"
                    value="cr"
                    checked={dr_cr === "cr"}
                    onChange={(e) => setDrCr(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="credit">
                    Cr
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dr_cr"
                    id="debit"
                    value="dr"
                    checked={dr_cr === "dr"}
                    onChange={(e) => setDrCr(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor="debit">
                    Dr
                  </label>
                </div>
              </div>
            </div>
            <div className="mt-2 d-flex justify-content-end">
              <input
                name="opening_balance"
                type="text"
                className="form-control"
                style={{ maxWidth: "220px" }}
                placeholder="Enter the amount"
                value={opening_balance}
                onChange={(e) =>
                  setOpeningBalance(validateAmount(e.target.value))
                }
              />
            </div>
            {errors.opening_balance && (
              <p className="alert-message text-end">{errors.opening_balance}</p>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="btn btn-cancel" onClick={onClose}>
          Close
        </Button>
        <Button variant="btn ripple btn-default" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddOpeningBalancePop;
